import { i as copy_payload, j as assign_payload, p as pop, a as push, k as ensure_array_like, h as head, c as attr_class, m as stringify, e as escape_html } from "../../../../chunks/index2.js";
import { M as Modal } from "../../../../chunks/Modal.js";
import { g as getToastState } from "../../../../chunks/Toast.svelte.js";
function _page($$payload, $$props) {
  push();
  const { data } = $$props;
  getToastState();
  let showConfirmModal = false;
  let showPaymentModal = false;
  const getPlanFeatures = (plan) => {
    return plan.features || [
      "Access to all legal documents",
      "Premium content library",
      "24/7 customer support",
      "Advanced search functionality"
    ];
  };
  const isPopularPlan = (plan) => {
    return plan.isPopular || plan.name.toLowerCase().includes("premium") || plan.name.toLowerCase().includes("pro");
  };
  let $$settled = true;
  let $$inner_payload;
  function $$render_inner($$payload2) {
    const each_array = ensure_array_like(data.plans);
    head($$payload2, ($$payload3) => {
      $$payload3.title = `<title>Subscription Plans - Kenya Law</title>`;
      $$payload3.out.push(`<meta name="description" content="Choose the perfect subscription plan for accessing Kenya's comprehensive legal document library. Flexible pricing for individuals and organizations."/>`);
    });
    $$payload2.out.push(`<main class="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 py-12"><div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8"><div class="text-center"><h1 class="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl lg:text-6xl">Choose Your Perfect Plan</h1> <p class="mx-auto mt-4 max-w-2xl text-lg text-gray-600 sm:text-xl">Get unlimited access to Kenya's most comprehensive legal document library. Choose the plan that fits your
				needs and budget.</p> <div class="mt-8 flex items-center justify-center space-x-6 text-sm text-gray-500"><div class="flex items-center"><i class="bi bi-shield-check mr-2 text-green-500"></i> <span>Secure &amp; Trusted</span></div> <div class="flex items-center"><i class="bi bi-arrow-clockwise mr-2 text-blue-500"></i> <span>Cancel Anytime</span></div> <div class="flex items-center"><i class="bi bi-headset mr-2 text-purple-500"></i> <span>24/7 Support</span></div></div></div> <div class="mt-16 grid grid-cols-1 gap-8 lg:grid-cols-3 lg:gap-6"><!--[-->`);
    for (let index = 0, $$length = each_array.length; index < $$length; index++) {
      let plan = each_array[index];
      const each_array_1 = ensure_array_like(getPlanFeatures(plan));
      $$payload2.out.push(`<div${attr_class(`hover:ring-primary relative flex flex-col overflow-hidden rounded-2xl bg-white shadow-lg ring-1 ring-gray-200 transition-all duration-150 hover:shadow-xl hover:ring-2 ${stringify(isPopularPlan(plan) ? "ring-primary scale-105 ring-2" : "")}`)}>`);
      if (isPopularPlan(plan)) {
        $$payload2.out.push("<!--[-->");
        $$payload2.out.push(`<div class="absolute -top-4 left-1/2 -translate-x-1/2"><span class="from-primary to-secondary inline-flex items-center rounded-full bg-gradient-to-r px-4 py-1 text-xs font-semibold text-white shadow-lg"><i class="bi bi-star-fill mr-1"></i> Most Popular</span></div>`);
      } else {
        $$payload2.out.push("<!--[!-->");
      }
      $$payload2.out.push(`<!--]--> <div${attr_class(`px-8 pt-8 pb-6 ${stringify(isPopularPlan(plan) ? "from-primary/5 to-secondary/5 bg-gradient-to-br" : "")}`)}><div class="text-center"><h3 class="text-2xl font-bold text-gray-900">${escape_html(plan.name)}</h3> <p class="mt-2 text-gray-600">${escape_html(plan.description)}</p> <div class="mt-6"><div class="flex items-baseline justify-center"><span class="text-5xl font-bold tracking-tight text-gray-900">KES ${escape_html(plan.price.toLocaleString())}</span></div> <p class="mt-1 text-sm text-gray-500">for ${escape_html(plan.duration)} days `);
      if (plan.duration >= 30) {
        $$payload2.out.push("<!--[-->");
        $$payload2.out.push(`<span class="ml-1 font-medium text-green-600/80">(KES ${escape_html(Math.round(plan.price / (plan.duration / 30)).toLocaleString())}/month)</span>`);
      } else {
        $$payload2.out.push("<!--[!-->");
      }
      $$payload2.out.push(`<!--]--></p></div></div></div> <div class="flex-1 px-8 pb-8"><ul class="space-y-4"><!--[-->`);
      for (let $$index = 0, $$length2 = each_array_1.length; $$index < $$length2; $$index++) {
        let feature = each_array_1[$$index];
        $$payload2.out.push(`<li class="flex items-start"><i class="bi bi-check-circle-fill mt-0.5 mr-3 flex-shrink-0 text-green-500"></i> <span class="text-gray-700">${escape_html(feature)}</span></li>`);
      }
      $$payload2.out.push(`<!--]--></ul></div> <div class="px-8 pb-8"><div class="mb-2 text-center"><button class="text-xs text-gray-400 underline hover:text-gray-600" title="Development: Direct subscribe without payment">sub</button></div> <button${attr_class(`block w-full rounded-lg px-4 py-3 text-center text-base font-semibold transition-all duration-200 ${stringify(isPopularPlan(plan) ? "from-primary to-secondary bg-gradient-to-r text-white shadow-lg hover:scale-105 hover:shadow-xl" : "bg-gray-900 text-white shadow-sm hover:bg-gray-800 hover:shadow-md")}`)}>Subscribe Now</button> <p class="mt-3 text-center text-xs text-gray-500">Upgrade or cancel anytime</p></div></div>`);
    }
    $$payload2.out.push(`<!--]--></div></div></main> `);
    Modal($$payload2, {
      title: "Confirm Your Subscription",
      get show() {
        return showConfirmModal;
      },
      set show($$value) {
        showConfirmModal = $$value;
        $$settled = false;
      },
      children: ($$payload3) => {
        {
          $$payload3.out.push("<!--[!-->");
        }
        $$payload3.out.push(`<!--]-->`);
      },
      $$slots: { default: true }
    });
    $$payload2.out.push(`<!----> `);
    {
      $$payload2.out.push("<!--[!-->");
    }
    $$payload2.out.push(`<!--]--> `);
    Modal($$payload2, {
      title: "Complete Your Subscription",
      modalClass: "max-w-4xl",
      get show() {
        return showPaymentModal;
      },
      set show($$value) {
        showPaymentModal = $$value;
        $$settled = false;
      },
      children: ($$payload3) => {
        $$payload3.out.push(`<div class="space-y-4"><div class="flex items-center justify-center space-x-2 text-sm text-gray-600"><i class="bi bi-shield-check text-green-500"></i> <span>Secure payment powered by PesaFlow</span></div> `);
        {
          $$payload3.out.push("<!--[!-->");
        }
        $$payload3.out.push(`<!--]--> <div class="relative h-full w-full">`);
        {
          $$payload3.out.push("<!--[!-->");
        }
        $$payload3.out.push(`<!--]--> <iframe class="h-[600px] w-full rounded-lg border border-gray-200" name="subscription_frame" title="Subscription Payment Form" onload="this.__e=event"></iframe></div> <div class="rounded-lg bg-blue-50 p-3"><div class="flex"><i class="bi bi-info-circle text-blue-400"></i> <div class="ml-2"><p class="text-xs text-blue-800"><strong>Note:</strong> Do not close this window until your payment is complete. Your subscription will activate
						immediately upon successful payment.</p></div></div></div></div>`);
      },
      $$slots: { default: true }
    });
    $$payload2.out.push(`<!---->`);
  }
  do {
    $$settled = true;
    $$inner_payload = copy_payload($$payload);
    $$render_inner($$inner_payload);
  } while (!$$settled);
  assign_payload($$payload, $$inner_payload);
  pop();
}
export {
  _page as default
};
